import axios, { AxiosResponse } from 'axios';

import { IApiListParams, INotificationApiListResponse } from '@/types';

export const loadNotifications = (params: IApiListParams): Promise<AxiosResponse<INotificationApiListResponse>> => {
    return axios.get('/api/notification/list', { params });
};

export const updateNotifications = (data: { rows: Record<string, any>[] }) => {
    return axios.post('/api/notification/update', data);
};

export const dismissAllNotifications = () => {
    return axios.get('/api/notification/dismissAll');
};
